var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotSureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.331 11.4448C17.239 11.4448 17.164 11.5198 17.165 11.6118C17.165 11.7028 17.24 11.7778 17.332 11.7778C17.424 11.7778 17.499 11.7028 17.499 11.6108C17.499 11.5188 17.424 11.4448 17.331 11.4448",
    stroke: "#FDCA40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.332 9.444C17.332 8.899 17.669 8.604 18.006 8.377C18.336 8.155 18.666 7.866 18.666 7.333C18.666 6.597 18.069 6 17.333 6C16.597 6 16 6.597 16 7.333",
    stroke: "#FDCA40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9993 16.6667V15.8333C14.9993 13.9924 13.507 12.5 11.666 12.5H4.99935C3.1584 12.5 1.66602 13.9924 1.66602 15.8333V16.6667",
    stroke: "#FDCA40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.33333,
    cy: 5.83333,
    r: 3.33333,
    stroke: "#FDCA40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSureIcon);
export default __webpack_public_path__ + "static/media/notSureIcon.5f93f3d3.svg";
export { ForwardRef as ReactComponent };